import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/api-client.config';
import { apiEndpoints } from '../endpoints';

interface ForcePickemScoringResponse {
  success: boolean;
  message?: string;
  entries_scored?: number;
}

async function forcePickemScoring(pickemId: string): Promise<ForcePickemScoringResponse> {
  return api.post(apiEndpoints.startScoringAsync(pickemId), {});
}

export function useForcePickemScoringMutation(pickemId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => forcePickemScoring(pickemId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['leaderboard', pickemId] });
      queryClient.invalidateQueries({ queryKey: ['pickems'] });
    },
  });
}
